<template>
  <Modal :is-open="isOpen" :modal-width="420" modal-height="fit-content" @update:isOpen="handleIsOpenUpdate" :closable="true">
    <template #body v-if="branding">
      <div class="merchant-body d-flex column items justify-center gap-24">
        <div class="merchant w-100 d-flex column justify-between items-center gap-16">
          <div class="avatar items-center bg-cont-blur-15">
            <img :src="user.avatar" :alt="user.name" class="w-100" />
          </div>
          <div class="d-flex column gap-16">
            <span class="text-h20 text-center text-bold leaning-28">
              {{ user.name }}
            </span>
            <span class="id d-flex items-center justify-center bg-cont-dim" v-if="user.zp_id">
              <MerchantId :id="user.zp_id.toString()" />
            </span>
          </div>
        </div>

        <div v-if="computeNoData" class="no-data color-on-cont-dim w-100 d-flex column justify-center items-center leaning-24">
          <span> پذیرنده اطلاعات بیشتری اینجا قرار نداده است. </span>
        </div>
        <div v-else class="merchant-data">
          <div class="wrapper">
            <AboutMerchant v-if="branding.bio" :description="branding.bio" />
            <div class="contact-merchant">
              <ContactMerchant v-if="branding?.contacts?.phone" :value="branding.contacts.phone" type="phone" />
              <ContactMerchant v-if="branding?.contacts?.email" :value="branding.contacts.email" type="email" />
              <ContactMerchant v-if="branding?.contacts?.address" :value="branding.contacts.address" type="address" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer v-if="branding?.contacts?.socials">
      <div class="social-media-container w-100 d-flex gap-8 items-center justify-center">
        <a
          v-for="(item, index) in getTheIconsList"
          :key="index"
          class="social-media-item bg-cont-dim d-flex items-center justify-center"
          :href="navigateToSocialMedia(item)"
          target="_blank"
          rel="noreferrer nofollow"
        >
          <Icons :name="item" />
        </a>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import Modal from '@/components/base/modal/index.vue';
import AboutMerchant from '@/components/merchant-profile/About-merchant.vue';
import ContactMerchant from '@/components/merchant-profile/contact-merchant.vue';
import MerchantId from '@/components/merchant-id/index.vue';
import type { ZarinMerchant } from '@/types';
import Icons from '@/components/base/icon/index.vue';
import type { IBranding } from '@/types/api';
import { computed, toRefs, type ComputedRef } from 'vue';
const props = defineProps<{
  isOpen: boolean;
  user: ZarinMerchant;
  branding: IBranding | null;
}>();

const { branding } = toRefs(props);
const emit = defineEmits(['update:isOpen']);
//
const getTheIconsList: ComputedRef = computed(() => {
  if (branding.value && branding.value.contacts.socials !== null) {
    return Object.keys(branding.value.contacts.socials);
  } else return [];
});
const navigateToSocialMedia = (socialMedia: string) => {
  const url = branding.value?.contacts.socials ? branding.value.contacts.socials[socialMedia] : '';
  return url;
};
function handleIsOpenUpdate(value: boolean) {
  emit('update:isOpen', value);
}
const computeNoData = computed(() => {
  return branding.value?.contacts && Object.values(branding.value.contacts).every((value) => value === null) && branding.value.bio === null;
});
</script>

<style scoped lang="scss">
@import url('./index.scss');
</style>
